import { forwardRef, type TextareaHTMLAttributes } from 'react';
import './Textarea.css';

export interface TextareaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  invalid?: boolean;
}

/** Multi-line text input. Use inside `FieldGroup` for label/help association. */
export const Textarea = forwardRef<HTMLTextAreaElement, TextareaProps>(function Textarea(
  { invalid = false, className, ...rest },
  ref
) {
  return (
    <textarea
      ref={ref}
      className={['dpr-textarea', invalid ? 'dpr-textarea--invalid' : null, className]
        .filter(Boolean)
        .join(' ')}
      {...rest}
    />
  );
});
